@if (showBookingQuestions) {
<div role="main" [attr.aria-label]="'Booking questions form'">
  @if ((widgetService.widgetConf | translation: 'lead_intro_text': lang)?.trim()) {
    <app-info-card
      [showBody]="true"
      role="region"
      [attr.aria-label]="'Introduction'"
    >
      <div cardBody>
        <app-csw-text
          [text]="widgetService.widgetConf | translation : 'lead_intro_text' : lang"
          role="text"
        />
      </div>
    </app-info-card>
  }
  <div class="mt-4" role="region" [attr.aria-label]="'Questions section'">
    @for (widgetQuestion of widgetQuestions; track widgetQuestion; let index = $index; let isFirst = $first; let isLast = $last) {
      <form
        #bookingQuestionForm="ngForm"
        role="form"
        [attr.aria-label]="'Question ' + (index + 1) + ' of ' + widgetQuestions.length"
        [attr.aria-describedby]="'question_progress_' + index"
      >
        <div
          [id]="'question_progress_' + index"
          class="visually-hidden"
          role="status"
          aria-live="polite"
        >
          Question {{ index + 1 }} of {{ widgetQuestions.length }}
        </div>
        @if (activeQuestion === index) {
          <app-booking-question
            [customField]="widgetQuestion"
            (radioButtonChangeEvent)="onRadioButtonChangeEvent($event)"
            [isNextButtonPressed]="isNextButtonPressed"
          />
          @if (widgetQuestion?.customFieldDependencies?.length > 0) {
            <div role="group" [attr.aria-label]="'Additional questions based on your selection'">
              @for (dependencyCustomField of widgetQuestion?.customFieldDependencies; track dependencyCustomField; let childIndex = $index; let childIsFirst = $first; let childIsLast = $last) {
                <app-booking-question
                  [customField]="dependencyCustomField"
                  (radioButtonChangeEvent)="onRadioButtonChangeEvent($event)"
                  [isNextButtonPressed]="isNextButtonPressed"
                />
              }
            </div>
          }
          @if (showDependenciesGhostElement) {
            <div
              class="skeleton-box-card mt-4"
              role="status"
              aria-live="polite"
              [attr.aria-label]="'Loading additional questions'"
            >
              <div>
                <div class="row">
                  @for (dependenciesGhostElement of dependenciesGhostElements; track $index) {
                    <div class="col-md-12 mb-4">
                      <div class="d-flex stats-card shadow">
                        <div
                          class="skeleton-animation w-100 d-flex justify-content-center flex-column ps-3"
                          aria-hidden="true"
                        >
                          <div class="bar bar-1"></div>
                          <div class="bar bar-2"></div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          @if (!showDependenciesGhostElement) {
            <div
              class="d-flex justify-content-end mt-4"
              role="navigation"
              [attr.aria-label]="'Question navigation'"
            >
              @if (widgetQuestion?.is_end_of_process !== 1 && !this.isEndOfProcessByChildDependencies) {
                <div class="me-2">
                  <app-button
                    id="booking-questions-previous-btn"
                    (clickEvent)="previousQuestion()"
                    [isDisabled]="isFirst"
                    [fontColor]="widgetService?.widgetConf?.button_font_color"
                    [backgroundColor]="widgetService?.widgetConf?.button_background_color"
                    role="button"
                    [attr.aria-label]="'Go to previous question'"
                    [attr.aria-disabled]="isFirst"
                  >
                    {{ "form_fields.previous" | translate }}
                  </app-button>
                </div>
                <div>
                  @if (!isLast) {
                    <app-button
                      id="booking-questions-next-btn"
                      (clickEvent)="nextQuestion()"
                      [isDisabled]="bookingQuestionForm.invalid"
                      [fontColor]="widgetService?.widgetConf?.button_font_color"
                      [backgroundColor]="widgetService?.widgetConf?.button_background_color"
                      role="button"
                      [attr.aria-label]="'Go to next question'"
                      [attr.aria-disabled]="bookingQuestionForm.invalid"
                    >
                      {{ "form_fields.next" | translate }}
                    </app-button>
                  } @else {
                    <app-button
                      id="booking-questions-next-btn"
                      (clickEvent)="finishLastBookingQuestion()"
                      [isDisabled]="bookingQuestionForm.invalid"
                      [fontColor]="widgetService?.widgetConf?.button_font_color"
                      [backgroundColor]="widgetService?.widgetConf?.button_background_color"
                      role="button"
                      [attr.aria-label]="'Finish questions'"
                      [attr.aria-disabled]="bookingQuestionForm.invalid"
                    >
                      {{ "form_fields.next" | translate }}
                    </app-button>
                  }
                </div>
              }
            </div>
          }
        }
      </form>
    }
  </div>
</div>
}
@if (showWrokerForm && workers?.length > 0) {
  <div role="region" [attr.aria-label]="'Worker selection'">
    <app-lead-workers-selection
      [workers]="workers"
      (previousPageEvent)="gotoLastQuestion()"
      (nextPageEvent)="gotoPersonalForm()"
    />
  </div>
}
@if (showPersonalForm) {
  <div role="region" [attr.aria-label]="'Personal information form'">
    @if ((widgetService.widgetConf | translation: 'lead_outro_text': lang)?.trim()) {
      <div>
        <app-info-card
          [showBody]="true"
          role="region"
          [attr.aria-label]="'Additional information'"
        >
          <div cardBody>
            <app-csw-text
              [text]="widgetService.widgetConf | translation : 'lead_outro_text' : lang"
              role="text"
            />
          </div>
        </app-info-card>
      </div>
    }
    <div class="mt-4">
      <app-personal-form
        [customerRequiredFields]="customerRequiredFields"
        [userInfo]="userInfo"
        [customerFormFields]="customerFormFields"
        [meetingTypes]="meetingTypes"
        (submitEvent)="onSubmitEvent($event)"
        (previousEvent)="gobackToStepFromPersonalForm()"
      />
    </div>
  </div>
}
